/* eslint-disable react/prop-types */
import React, { CSSProperties, Component } from 'react';
import styles from './styles.css';

function emptyFunc() {}

interface SplitLineProps {
    direction: string;
    draggable: boolean;
    style: CSSProperties;
    beforeDrag?: (e?) => void;
    onDrag?: (e?, offset?: { offsetX: number; offsetY: number }) => void;
    afterDrag?: (e?, offset?: { offsetX: number; offsetY: number }) => void;
}

export default class SplitLine extends Component<SplitLineProps> {
    public static defaultProps = {
        direction: 'horizontal',
        draggable: false,
        beforeDrag: emptyFunc,
        onDrag: emptyFunc,
        afterDrag: emptyFunc,
    };

    private startX: number;
    private startY: number;
    public constructor(props, context) {
        super(props, context);

        this.startX = 0;
        this.startY = 0;
    }

    public componentWillUnmount() {
        this.removeEventListener();
    }

    public render() {
        let className = `${styles['split-line']}`;
        this.props.direction && (className += ` ${styles[`split-line-${this.props.direction}`]}`);

        return (
            <div
                className={className}
                onMouseDown={this.handleMouseDown}
                style={this.props.style}
            >
            </div>
        );
    }

    private addEventListener = () => {
        window.addEventListener('mousemove', this.handleMouseMove, true); // 优先级最高
        window.addEventListener('mouseup', this.handleMouseUp, true); // 优先级最高
    };

    private removeEventListener = () => {
        window.removeEventListener('mousemove', this.handleMouseMove, true);
        window.removeEventListener('mouseup', this.handleMouseUp, true);
    };

    private handleMouseMove = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.props.onDrag?.(e, {
            offsetX: e.clientX - this.startX,
            offsetY: e.clientY - this.startY,
        });
    };

    private handleMouseUp = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.props.afterDrag?.(e, {
            offsetX: e.clientX - this.startX,
            offsetY: e.clientY - this.startY,
        });

        this.removeEventListener();
    };

    private handleMouseDown = (e) => {
        e.preventDefault();
        e.stopPropagation();
        // 返回true阻止drag
        if (!this.props.beforeDrag?.(e) && this.props.draggable) {
            this.startX = e.clientX;
            this.startY = e.clientY;
            this.addEventListener();
        }
    };
}
